module.exports = __webpack_public_path__ + "images/360.46420a.png";